import { url, tokenRef } from "api";

// MERGING A PARTNER COMPANY RECORD INTO ANOTHER. Super admin only, enforced
// on the server (routes/adminPartnerMerge.js). Preview first, run the plan
// the server recomputes, undo from the backup it wrote.

const headers = () => {
  const h = { "Content-Type": "application/json" };
  const t = localStorage.getItem(tokenRef);
  if (t) h["Authorization"] = `Bearer ${t}`;
  return h;
};

// The error carries the body: a refused run answers with the fresh plan, and
// a refused undo with the rows changed since.
const handle = async (r) => {
  const d = await r.json().catch(() => ({}));
  if (!r.ok) {
    const e = new Error(d.err || "Request failed");
    e.status = r.status;
    e.plan = d.plan;
    e.drift = d.drift;
    throw e;
  }
  return d;
};

const post = async (path, body) =>
  handle(await fetch(`${url}/partner-merge${path}`, { method: "POST", headers: headers(), body: JSON.stringify(body) }));

export const getMergeTargets = async (q = "") =>
  handle(await fetch(`${url}/partner-merge/targets?q=${encodeURIComponent(q)}`, { headers: headers() }));

export const previewMerge = (sourceId, targetId, keepTarget = []) =>
  post("/preview", { sourceId, targetId, keepTarget });

// `fingerprint` is the preview's: the server refuses if what it would change
// now differs from what was shown. `confirmName` is the merged company's name, typed.
export const runMerge = (sourceId, targetId, { keepTarget = [], fingerprint, confirmName }) =>
  post("/run", { sourceId, targetId, keepTarget, fingerprint, confirmName });

export const undoMerge = (runId, force = false) => post("/undo", { runId, force });
